module.exports = __webpack_public_path__ + "img/NO816521432.f68d7d80.png";